import { render, staticRenderFns } from "./noFoundCookiesPage.vue?vue&type=template&id=29caea76&"
import script from "./noFoundCookiesPage.vue?vue&type=script&lang=ts&"
export * from "./noFoundCookiesPage.vue?vue&type=script&lang=ts&"
import style0 from "./noFoundCookiesPage.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports